import { blueprint } from "../../blueprint";

/** Logo du projet s'il en a un, sinon monogramme sur fond primaire. */
export function BrandMark({ size = 34 }: { size?: number }) {
  if (blueprint.brand.logo) {
    return (
      <span className="brand-mark brand-mark--logo" aria-hidden="true">
        <img src={blueprint.brand.logo} alt="" width={size} height={size} />
      </span>
    );
  }
  return (
    <span className="brand-mark brand-mark--mono" aria-hidden="true">
      {blueprint.name.charAt(0).toUpperCase()}
    </span>
  );
}
